/**
 * Android notification categories
 */
export var NotificationCategory;
(function (NotificationCategory) {
    NotificationCategory["ALARM"] = "alarm";
    NotificationCategory["CALL"] = "call";
    NotificationCategory["EMAIL"] = "email";
    NotificationCategory["ERROR"] = "err";
    NotificationCategory["EVENT"] = "event";
    NotificationCategory["LOCATION_SHARING"] = "location_sharing";
    NotificationCategory["MESSAGE"] = "msg";
    NotificationCategory["MISSED_CALL"] = "missed_call";
    NotificationCategory["NAVIGATION"] = "navigation";
    NotificationCategory["PROGRESS"] = "progress";
    NotificationCategory["PROMO"] = "promo";
    NotificationCategory["RECOMMENDATION"] = "recommendation";
    NotificationCategory["REMINDER"] = "reminder";
    NotificationCategory["SERVICE"] = "service";
    NotificationCategory["SOCIAL"] = "social";
    NotificationCategory["STATUS"] = "status";
    NotificationCategory["STOPWATCH"] = "stopwatch";
    NotificationCategory["SYSTEM"] = "sys";
    NotificationCategory["TRANSPORT"] = "transport";
    NotificationCategory["VOICEMAIL"] = "voicemail";
    NotificationCategory["WORKOUT"] = "workout";
    NotificationCategory["UNKNOWN"] = "unknown";
})(NotificationCategory || (NotificationCategory = {}));
/**
 * Android notification styles
 */
export var NotificationStyle;
(function (NotificationStyle) {
    NotificationStyle["BIG_TEXT"] = "BigTextStyle";
    NotificationStyle["BIG_PICTURE"] = "BigPictureStyle";
    NotificationStyle["INBOX"] = "InboxStyle";
    NotificationStyle["MESSAGING"] = "MessagingStyle";
    NotificationStyle["MEDIA"] = "MediaStyle";
    NotificationStyle["CALL"] = "CallStyle";
    NotificationStyle["DECORATED_CUSTOM"] = "DecoratedCustomViewStyle";
    NotificationStyle["DECORATED_MEDIA"] = "DecoratedMediaCustomViewStyle";
    NotificationStyle["DEFAULT"] = "default";
})(NotificationStyle || (NotificationStyle = {}));
//# sourceMappingURL=definitions.js.map